import { render, staticRenderFns } from "./MaidGeneral.vue?vue&type=template&id=08b290cf&"
import script from "./MaidGeneral.vue?vue&type=script&lang=js&"
export * from "./MaidGeneral.vue?vue&type=script&lang=js&"
import style0 from "./MaidGeneral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidGeneral.vue"
export default component.exports